import { api } from "@/services/api"

export interface HijackResponse {
  access_token: string
  token_type: string
  user: {
    id: string
    name: string
    email: string
    organization_id: string
    default_provider_id: string
    onboarding_completed: boolean
    roles?: string[]
    created_at?: string
  }
  impersonator_id: string
}

export const hijackService = {
  hijackUser: (userId: string) => api.post<HijackResponse>(`/admin/views/users/${userId}/hijack`),
}
